import { Servis } from './Servis';
import { durumSifirla } from '@/baslarken/durum';

// Oturumdaki kullanıcının şirketinin aktif paketleri.
// Modül düzeyinde tek promise ile cache'lenir: aynı sayfa yüklemesinde
// birden çok bileşen çağırsa da 1 istek atılır; sayfa yenilenince (F5) modül
// yeniden yüklendiği için taze çekilir. Login/logout'ta resetLisansCache ile sıfırlanır.
let _lisansPromise = null;
// YNL1-1: ayni istegin ham satirlari (Kod + BitisTarih) — Satin Al'da "Bitis" / "Yeni bitis" icin.
let _hamPromise = null;
// SK-S/V10: saglayici Sirket 360 "Ayarlar" sekmesinden baska sirketleri gezerken, her hedef
// sirket icin ayri bir cache anahtari - tek _lisansPromise'a yazilsaydi bir onceki sirketin
// lisans seti bir sonraki sirkette de goruluyordu (yanlis-sirket verisi sizmasi).
const _lisansPromiseBySirket = new Map();

export function resetLisansCache() {
  _lisansPromise = null;
  _hamPromise = null;
  _lisansPromiseBySirket.clear();
  // BSL: login/çıkış ve ilk lisans etkinleşmesi aynı noktadan geçer — Başlarken durumu da tazelensin.
  durumSifirla();
}

function _fetchHam(sirketQuery) {
  return (async () => {
    try {
      const res = await Servis('GET', 'GetAktifLisanslarim' + sirketQuery, '');
      return (res.status === 200 && Array.isArray(res.data)) ? res.data : [];
    } catch {
      return [];
    }
  })();
}

// LS3: Kod, Ad'dan bağımsız kapı anahtarı (LISANS-SISTEMI-PLANI.md V1).
const _kodKumesi = (satirlar) => new Set(satirlar.map(x => String(x.Kod || '').toLowerCase()));

function _fetchLisanslar(sirketQuery) {
  return _fetchHam(sirketQuery).then(_kodKumesi);
}

// pSirket verilirse (saglayici baska sirketi duzenlerken) o sirkete ozel, ayri cache'lenmis
// sonuc doner; verilmezse (cogu cagiran) mevcut token-sirketi davranisi ve cache'i degismez.
export function getAktifLisanslar(pSirket) {
  const hedef = Number(pSirket) || 0;
  if (hedef > 0) {
    if (_lisansPromiseBySirket.has(hedef)) return _lisansPromiseBySirket.get(hedef);
    const p = _fetchLisanslar('?Sirket_rowid=' + hedef);
    _lisansPromiseBySirket.set(hedef, p);
    return p;
  }
  if (_lisansPromise) return _lisansPromise;
  if (!_hamPromise) _hamPromise = _fetchHam('');
  _lisansPromise = _hamPromise.then(_kodKumesi);
  return _lisansPromise;
}

// YNL1-1: oturumdaki şirketin aktif lisanslarının bitişi — Map<kod (küçük harf), BitisTarih>.
// getAktifLisanslar ile aynı isteği paylaşır (ek istek yok).
export function getAktifLisansBitisleri() {
  if (!_hamPromise) _hamPromise = _fetchHam('');
  return _hamPromise.then((satirlar) => {
    const m = new Map();
    satirlar.forEach((x) => {
      const kod = String(x.Kod || '').toLowerCase();
      if (kod && x.BitisTarih) m.set(kod, x.BitisTarih);
    });
    return m;
  });
}

// Bir kart/QR gösterilsin mi?
export function kartGoster(gerekliPaket, aktifSet) {
  if (!gerekliPaket) return true;                    // temel öğe → her zaman
  if (aktifSet && aktifSet.has('sistemadmin')) return true;  // admin bypass
  return !!aktifSet && aktifSet.has(String(gerekliPaket).toLowerCase());
}
